import { toast } from 'sonner'

import cn from './SupplierArticlesValue.module.scss'

const copyArticle = (article: string) =>
  navigator.clipboard
    .writeText(article)
    .then(() => toast.success(`Скопировано: ${article}`))
    .catch(() => toast.error('Не удалось скопировать артикул'))

function SupplierArticlesValue({ articles }: { articles: string[] }) {
  return (
    <span className={cn.chips}>
      {articles.map((article) => (
        <button
          key={article}
          type="button"
          className={cn.chip}
          title="Скопировать"
          onClick={(event) => {
            event.stopPropagation()
            void copyArticle(article)
          }}
        >
          {article}
        </button>
      ))}
    </span>
  )
}

export default SupplierArticlesValue
